/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuslastungsplanungDocument } from '../models/AuslastungsplanungDocument';
import type { AuslastungsplanungDocumentKeys } from '../models/AuslastungsplanungDocumentKeys';
import type { PutAuslastungsplanungDocument } from '../models/PutAuslastungsplanungDocument';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuslastungsplanungService {
    /**
     * lists the keys of all stored planning documents
     * @param tenantId tenant_id
     * @returns AuslastungsplanungDocumentKeys returns the sorted list of keys
     * @throws ApiError
     */
    public static getAuslastungsplanungDocuments(
        tenantId: string,
    ): CancelablePromise<AuslastungsplanungDocumentKeys> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/planning/auslastungsplanung/documents',
            path: {
                'tenant_id': tenantId,
            },
            errors: {
                401: `unauthorized when employee does not have access to the tenant`,
                403: `forbidden when auslastungsplanung_prototype toggle is disabled`,
            },
        });
    }
    /**
     * returns the planning document for a key
     * @param tenantId tenant_id
     * @param key document key
     * @returns AuslastungsplanungDocument returns key and payload
     * @throws ApiError
     */
    public static getAuslastungsplanungDocument(
        tenantId: string,
        key: string,
    ): CancelablePromise<AuslastungsplanungDocument> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/planning/auslastungsplanung/documents/{key}',
            path: {
                'tenant_id': tenantId,
                'key': key,
            },
            errors: {
                401: `unauthorized when employee does not have access to the tenant`,
                403: `forbidden when auslastungsplanung_prototype toggle is disabled`,
                404: `not found for an unknown key`,
            },
        });
    }
    /**
     * creates or replaces the planning document for a key
     * @param tenantId tenant_id
     * @param key document key
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putAuslastungsplanungDocument(
        tenantId: string,
        key: string,
        requestBody?: PutAuslastungsplanungDocument,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tenants/{tenant_id}/planning/auslastungsplanung/documents/{key}',
            path: {
                'tenant_id': tenantId,
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `unauthorized when employee does not have access to the tenant`,
                403: `forbidden when auslastungsplanung_prototype toggle is disabled`,
            },
        });
    }
}
